import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCallback } from 'react'

export function useNavigateWithParams() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const navigateWithParams = useCallback(
    (path: string, additionalParams?: Record<string, string>) => {
      const currentParams = new URLSearchParams(searchParams)

      if (additionalParams) {
        Object.entries(additionalParams).forEach(([key, value]) => {
          currentParams.set(key, value)
        })
      }

      const queryString = currentParams.toString()
      const fullPath = queryString ? `${path}?${queryString}` : path

      navigate(fullPath)
    },
    [navigate, searchParams]
  )

  const navigateWithoutParams = useCallback(
    (path: string, paramsToRemove: string[]) => {
      const currentParams = new URLSearchParams(searchParams)

      paramsToRemove.forEach((param) => {
        currentParams.delete(param)
      })

      const queryString = currentParams.toString()
      const fullPath = queryString ? `${path}?${queryString}` : path

      navigate(fullPath)
    },
    [navigate, searchParams]
  )

  const getPathWithParams = useCallback(
    (path: string): string => {
      const queryString = searchParams.toString()
      return queryString ? `${path}?${queryString}` : path
    },
    [searchParams]
  )

  return {
    navigateWithParams,
    navigateWithoutParams,
    getPathWithParams,
  }
}
